// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import { ThemeProvider } from "./context/ThemeContext";
// import AppShell from "./layout/AppShell";
// import Dashboard from "./pages/Dashboard";
// import Products from "./pages/Products";
// import Activities from "./pages/Activities";
// import SalesAndPurchases from "./pages/SalesAndPurchases";
// import Transactions from "./pages/Transactions";
// import Production from "./pages/Production";
// import Inventory from "./pages/Inventory";
// import Approval from "./pages/Approval";
// import Reports from "./pages/Reports";
// import AIInsights from "./pages/AIInsights";
// import Users from "./pages/Users";

// export default function App() {
//   return (
//     <ThemeProvider>
//       <Routes>
//         <Route path="/" element={<AppShell />}>
//           <Route index element={<Dashboard />} />
//           <Route path="products" element={<Products />} />
//           <Route path="activities" element={<Activities />} />
//           <Route path="sales-and-purchases" element={<SalesAndPurchases />} />
//           <Route path="transactions" element={<Transactions />} />
//           <Route path="production" element={<Production />} />
//           <Route path="inventory" element={<Inventory />} />
//           <Route path="approval" element={<Approval />} />
//           <Route path="reports" element={<Reports />} />
//           <Route path="ai-insights" element={<AIInsights />} />
//           <Route path="users" element={<Users />} />
//         </Route>
//       </Routes>
//     </ThemeProvider>
//   );
// }





//       Login wala 

import React, { useState,useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";

import AppShell from "./layout/AppShell";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Activities from "./pages/Activities";
import SalesAndPurchases from "./pages/SalesAndPurchases";
import Transactions from "./pages/Transactions";
import Production from "./pages/Production";
import Inventory from "./pages/Inventory";
import Approval from "./pages/Approval";
import Reports from "./pages/Reports";
import AIInsights from "./pages/AIInsights";
import Users from "./pages/Users";

// 👉 ADD THIS
import Login from "./components/login/Login"; // path check kar lena
import Logout from "./pages/Logout";
import AddCategory from "./pages/production/AddCategory";
import WarehouseForm from "./pages/production/WarehouseForm";

// 👉 auth check
const isLoggedIn = () => {
  return localStorage.getItem("userData");
};
// const SESSION_TIMEOUT = 5 * 60 * 1000; // 30 min

export default function App() {
 const [isAuth, setIsAuth] = useState(
  !!localStorage.getItem("userData")
);
  //  useEffect(() => {
  //   const checkAuth = () => {
  //     const user = localStorage.getItem("userData");
  //     const loginTime = localStorage.getItem("loginTime");

  //     if (!user || !loginTime) {
  //       setIsAuth(false);
  //       return;
  //     }

  //     const currentTime = Date.now();

  //     // ⛔ TIME EXPIRED
  //     if (currentTime - loginTime > SESSION_TIMEOUT) {
  //       console.log("⏳ Session expired → Auto logout");

  //       localStorage.removeItem("userData");
  //       localStorage.removeItem("loginInfo");
  //       localStorage.removeItem("sessionId");

  //       setIsAuth(false);

  //       window.location.href = "/login"; // 🔁 force redirect
  //     } else {
  //       setIsAuth(true);
  //     }
  //   };

  //   checkAuth();

  //   // ⏱ har 1 min check karo
  //   const interval = setInterval(checkAuth, 60*1000);

  //   return () => clearInterval(interval);
  // }, []);
  return (
    <ThemeProvider>
      <Routes>

        {/* 🔓 LOGIN ROUTE */}
        <Route
          path="/login"
          element={
            !isLoggedIn() ? <Login setIsAuth={setIsAuth} /> : <Navigate to="/"/>
          }
        />

        {/* 🔐 PROTECTED ROUTES */}
       <Route
          path="/"
          element={
            isAuth ? <AppShell setIsAuth={setIsAuth} /> : <Navigate to="/login" />
          }
        >
          
          <Route index element={<Dashboard />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="products" element={<Products />} />
          <Route path="create" element={<WarehouseForm />} />
          <Route path="production/add-category" element={<AddCategory />} />
          <Route path="activities" element={<Activities />} />
          <Route path="sales-and-purchases" element={<SalesAndPurchases />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="production" element={<Production />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="approval" element={<Approval />} />
          <Route path="reports" element={<Reports />} />
          <Route path="ai-insights" element={<AIInsights />} />
          <Route path="users" element={<Users />} />
        </Route>

      </Routes>
    </ThemeProvider>
  );
}

              /////////////




           // withoutlogin

// import React from "react";
// import { Routes, Route,Navigate } from "react-router-dom";
// import { ThemeProvider } from "./context/ThemeContext";

// import AppShell from "./layout/AppShell";
// import Dashboard from "./pages/Dashboard";
// import Products from "./pages/Products";
// import Activities from "./pages/Activities";
// import SalesAndPurchases from "./pages/SalesAndPurchases";
// import Transactions from "./pages/Transactions";
// import Production from "./pages/Production";
// import Inventory from "./pages/Inventory";
// import Approval from "./pages/Approval";
// import Reports from "./pages/Reports";
// import AIInsights from "./pages/AIInsights";
// import Users from "./pages/Users";

// // ❌ Login import bhi hata do (important)
// // import Login from "./components/login/Login";

// export default function App() {
//   return (
//     <ThemeProvider>
//       <Routes>

//         {/* ❌ LOGIN ROUTE REMOVE */}
//  <Route path="/login" element={<Navigate to="/" replace />} />
//         {/* ✅ DIRECT APP */}
//         <Route path="/" element={<AppShell />}>
//           <Route index element={<Dashboard />} />
//           <Route path="products" element={<Products />} />
//           <Route path="activities" element={<Activities />} />
//           <Route path="sales-and-purchases" element={<SalesAndPurchases />} />
//           <Route path="transactions" element={<Transactions />} />
//           <Route path="production" element={<Production />} />
//           <Route path="inventory" element={<Inventory />} />
//           <Route path="approval" element={<Approval />} />
//           <Route path="reports" element={<Reports />} />
//           <Route path="ai-insights" element={<AIInsights />} />
//           <Route path="users" element={<Users />} />
//         </Route>

//       </Routes>
//     </ThemeProvider>
//   );
// }